export const singaporeCoordinates: Record<string, { lat: number; lng: number }> = {
  'Singapore Changi Airport': { lat: 1.3644, lng: 103.9915 },
  'Changi Airport': { lat: 1.3644, lng: 103.9915 },
  'Night Safari Singapore': { lat: 1.4019, lng: 103.7884 },
};

export const singaporeCenter = { lat: 1.38, lng: 103.89 };
